export default "__VITE_ASSET__CobZYYuq__"